import type { ApiListRequest, ApiListResponseV3 } from "../@types/services/Api";
import type {
  PurchaseGroup,
  PurchaseGroupsFilter,
} from "../@types/services/PurchaseGroup";
import { api } from "./api";

const API_BASE_URL = "/api/v3/purchase_groups";

export const fetchPurchaseGroups = async ({
  filters,
  ...rest
}: ApiListRequest<PurchaseGroupsFilter> = {}): Promise<
  ApiListResponseV3<PurchaseGroup>
> => {
  const response = await api.get<ApiListResponseV3<PurchaseGroup>>("", {
    baseURL: API_BASE_URL,
    params: {
      ...filters,
      ...rest,
    },
  });

  return response.data;
};
